import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/baloo-2/600.css';
import '@fontsource/baloo-2/800.css';
import '@fontsource/figtree/400.css';
import '@fontsource/figtree/600.css';
import './styles.css';
import { App } from './ui/App';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { installErrorReporting } from './net/telemetry';
import { installSoundUnlock } from './audio/sound';

installErrorReporting();
installSoundUnlock();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
